module.exports = __webpack_public_path__ + "img/arrow-top.af09083a.svg";